// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1tj4v","title":"AfterBackImages_title__1vbyx","images":"AfterBackImages_images__3VKLe"};